import styled from 'styled-components';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ParentCategory = styled(CustomLink)`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  padding: 7.5px 0;

  &:hover {
    color: ${({ theme }) => theme.palette.brand.main};

    & path {
      fill: ${({ theme }) => theme.palette.brand.main};
    }
  }
`;

export const ParentCategoryLoader = styled.div`
  padding: 7.5px 0;
`;

export const CurrentCategory = styled(Typography.Title).attrs({
  $variant: '4',
})`
  font-size: 15px;
  padding: 10px 15px;
`;

export const CurrentCategoryLoader = styled.div`
  padding: 10px 15px;
`;

export const Category = styled(ParentCategory)`
  padding-left: 30px;
`;

export const CategoryLoader = styled(ParentCategoryLoader)`
  padding-left: 30px;
`;
